module.exports = __webpack_public_path__ + "media/12_the_balance_of_life.8291c536.mp3";